// extracted by mini-css-extract-plugin
module.exports = {"GrowBox":"Growyour_GrowBox__2DFOo","swiper_Avi":"Growyour_swiper_Avi__3_j4O","GrowFirst":"Growyour_GrowFirst__2abw7","SwiperSlide_Avi":"Growyour_SwiperSlide_Avi__2COko"};